<ion-header translucent>
  <ion-toolbar>
    <ion-title>{{ 'Mobile.Journal' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="onDismiss()">{{ 'Mobile.Close' | translate }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-button *ngIf="callcard.hasDatabaseChanged" expand="block" fill="solid" (click)="onRefreshClicked()">
    <ion-icon slot="start" name="refresh"></ion-icon>
    <ion-label>{{ 'Mobile.Refresh' | translate }}</ion-label>
  </ion-button>
</ion-header>

<ion-content>
  <app-journal-list [journalItems]="journalItems" [title]="title"></app-journal-list>
</ion-content>
